function integrationPos(integrationSettingsService, integrationConstant,
                        appConfig, integrationViewPosService) {
    const vm = this;
    const isMerchantAdminLocation = () => vm.location === integrationConstant.LOCATION.merchantAdmin.label;
    const isPosPartnerVisible = (posType) => integrationViewPosService.isPosPartnerVisible(posType, vm.location);
    const getDisplay =
        (options, featureKey) => integrationViewPosService.isFeatureVisible(options, vm.location)[featureKey];

    const sharedComponentDisplay = (toggleSet) => {
        const isBarOrPat = toggleSet.payAtTable || toggleSet.barTab;
        vm.isBarAndPatFeatureVisible = integrationViewPosService
            .isBarAndPatChildComponentVisible(vm.location, isBarOrPat);
    };
    const manageDisplay = () => {
        const integrationDetails = integrationSettingsService.integrationDetails(vm.data);
        vm.visible = {
            isSummaryVisible: appConfig.isElevatedUser &&
                isMerchantAdminLocation() &&
                vm.outletsSummaryData !== undefined && vm.outletsSummaryData !== null,

            isMerchantFeature: isMerchantAdminLocation(),
            isPayAtTableVisible: getDisplay({posType: vm.data.posType}, integrationConstant.POS_FEATURE.PAY_AT_TABLE),
            isBarTabVisible: getDisplay({posType: vm.data.posType}, integrationConstant.POS_FEATURE.BAR_TAB),
            isCollectionVisible: getDisplay({posType: vm.data.posType}, integrationConstant.POS_FEATURE.COLLECTION),
            isMicrosFeature: isMerchantAdminLocation() && integrationDetails.isMicros,
            isPosPartnerVisible: isPosPartnerVisible(vm.data.posType),
            posSelect: {
                display: true,
                disabled: vm.data.isUseMerchantSettings
            }
        };
        const mapVisibleFeature = integrationViewPosService.getPosMapDisplay(vm.data, vm.location);
        vm.payAtTableDisplayMap = mapVisibleFeature.payAtTable;
        vm.barTabDisplayMap = mapVisibleFeature.barTab;
        vm.collectionDisplayMap = mapVisibleFeature.collection;
        vm.barAndPatDisplayMap = mapVisibleFeature.barAndPat;
    };
    vm.updatePosType = () => {
        vm.onChangePos({posType: vm.data.posType});
        vm.updatePosFeatureToggle(vm.toggleSet);
        manageDisplay();
    };
    vm.updatePosData = () => {
        vm.onDataUpdate({updatedData: vm.data});
        manageDisplay();
    };
    vm.updateData = (updatedData) => {
        vm.onDataUpdate({updatedData});
    };
    vm.updatePosFeatureToggle = (toggleSet) => {
        // this is for the at least one toggle selected for Micros
        vm.oneToggleSelected = integrationViewPosService.isAtLeastOneToggleSelected(toggleSet, vm.data.posType);
        // shared pat and bar tab components
        sharedComponentDisplay(toggleSet);
    };
    vm.cleanSubFeature = (data) => {
        vm.onToggleCleanSubFeature({data});
    };
    vm.$onInit = () => {
        vm.posTypes = integrationSettingsService.getPosTypes();
        vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
        vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        manageDisplay();
        vm.toggleSet = {
            payAtTable: vm.data.payAtTable,
            barTab: vm.data.barTab,
            collection: vm.data.collection
        };
        vm.updatePosFeatureToggle(vm.toggleSet);
    };
    vm.$onChanges = (changesObj) => {
        if (changesObj.integrationData) {
            // Changes in the integrationData on the parent needs to be update
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            vm.toggleSet = {
                payAtTable: vm.data.payAtTable,
                barTab: vm.data.barTab,
                collection: vm.data.collection
            };
            vm.updatePosFeatureToggle(vm.toggleSet);
            manageDisplay();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('integrationPos', {
        template: require('./integration-pos.html'),
        bindings: {
            integrationData: '<',
            parentData: '<?',
            integrationForm: '<',
            outletsSummaryData: '<',
            posPartners:'<',
            selectedType: '<',
            location: '<',
            onChangePos: '&',
            onDataUpdate: '&',
            onToggleCleanSubFeature: '&'
        },
        controller: integrationPos,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/integration.pos.component.js